// The UserAdvice module: the advice classes that decide which buttons the current-log
// row and day summary offer, and the dialogs those buttons open. Split out of
// App/UserAdvice.tsx + the Views/UserAdviceViews.tsx barrel in #1171 so the whole
// feature sits in one directory, the way Components/LogButton and Views/Day do.
export { UserAdvice, UserAdviceInstance, UserAdviceLocation, isUserAdviceMonitor } from "./Advice"
export type { UserAdviceMonitor, UserAdviceState } from "./Advice"
export { getUserAdvices, userAdvicesByRole } from "./Advices"
export { AlertAdvice } from "./AlertAdvice"
export { AnchorMonitorAdvice } from "./AnchorMonitorAdvice"
export { AnchorWatchFailure, anchorWatchFailure } from "./AnchorWatchFailure"
export { DepthWatchAdvice } from "./DepthWatchAdvice"
export { LightsReminderAdvice } from "./LightsReminderAdvice"
export { EngineMissingAdvice, ENGINE_MISSING_PROVISIONAL_KEY } from "./EngineMissingAdvice"
export { ManualShipStatusAdvice } from "./ManualShipStatusAdvice"
export { StopUserAdvice, SPEED_CHANGE_STOP_PROVISIONAL_KEY } from "./StopAdvice"

export { UserAdviceOverlayContent, UserAdviceOverlayView } from "./OverlayContentView"
export { UserAdviceViewsData } from "./Context"
export type { UserAdviceViewProps } from "./Params"
export { UserAdviceAlertView } from "./AlertView"
export { UserAdviceAnchorMonitorView } from "./AnchorMonitorView"
export { UserAdviceDepthWatchView } from "./DepthWatchView"
export { UserAdviceLightsReminderView } from "./LightsReminderView"
export { UserAdviceEngineMissingView } from "./EngineMissingView"
export { UserAdviceManualShipStatusView } from "./ManualShipStatusView"
export { UserAdviceStopView } from "./StopView"
